export default function CustomSelect({ title, checked, setCheck }) {
  const CheckOnChangeHandler = () => {
    setCheck(!checked)
  }
  return (
    <label className="flex items-center gap-3">
      <input
        type="radio"
        name={title}
        className="form-radio h-5 w-5 border-gray-accent bg-white text-gray-accent transition duration-300 ease-in-out checked:bg-gray-accent focus:ring-0 lg-c:h-6 lg-c:w-6"
        checked={checked}
        onChange={CheckOnChangeHandler}
      />
      <span className="text-nowrap">{title}</span>
    </label>
  )
}
